import React, { useContext } from "react";
import translations from "../data/langData";
import { LanguageContext } from '../context/LanguageContext';
const Footer = () => {
  const date = new Date();
  const currentDate = date.getFullYear() ;
  const { language } = useContext(LanguageContext);
  const t = translations[language];
  return (
    <>
      <footer className="footer-area">
        <div className="container">
          <div className="text text-center">
            <p>
            © {currentDate} Copyright | {t.reserved}
            </p>
          </div>
        </div>
      </footer>
    </>
  );
};

export default Footer;
